import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B090LocationIdoRequest = {
  shohinCd: string;
  haraidashilocationCd: string;
  ukeirelocationCd: string;
  idosu: string;
} & Partial<{
  meisaibiko: string;
}>;

export type B090030CreateRequest = {
  idouYmd: string;
  shainCd: string;
  bumonCd: string;
} & Partial<{ locationIdouList: B090LocationIdoRequest[] }>;

// 登録処理
export const B090030Create = (props: B090030CreateRequest) => {
  return RestClient.post("b090030/create", props);
};

export type B090030GetRequest = {
  locationCd: string;
  shohinCd: string;
};

export const B090030GetHikiate = (props: B090030GetRequest) => {
  return RestClient.get("b090030/get/hikiate", {
    params: props,
  });
};

//可能数取得処理
export const B090030Kanosu = (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCd === "" || data.haraidashilocationCd === "") {
    methods.setValue("kanosu", "");
    return;
  }
  B090030GetHikiate({
    shohinCd: data.shohinCd,
    locationCd: data.haraidashilocationCd,
  })
    .then((response) => {
      methods.setValue("kanosu", response.data.kanosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("kanosu", "");
    });
};
